import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import axios from "axios";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';

const BLogCardHome = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_BLOGS;
        const cacheKey = "homeBlogs";
        const cacheTimeKey = "homeBlogsTimestamp";
        const cacheExpiry = 30 * 60 * 1000; // 30 minutes

        const cachedBlogs = localStorage.getItem(cacheKey);
        const cacheTimestamp = localStorage.getItem(cacheTimeKey);

        if (cachedBlogs && cacheTimestamp && (Date.now() - parseInt(cacheTimestamp, 10)) < cacheExpiry) {
            setBlogs(JSON.parse(cachedBlogs));
        } else {
            axios.get(`${apiBaseUrl}${Url}`)
                .then(response => {
                    setBlogs(response.data);
                    localStorage.setItem(cacheKey, JSON.stringify(response.data));
                    localStorage.setItem(cacheTimeKey, Date.now().toString());
                })
                .catch(error => console.error("Failed to fetch blogs:", error));
        }
    }, []);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow: <button className="custom-prev">Prev</button>,
        nextArrow: <button className="custom-next">Next</button>,
        centerMode: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 2000,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 3000,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <div className="blog-area pb-100">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 mx-auto">
                        <div className="site-heading text-center wow fadeInDown" data-wow-delay=".25s">
                            <span className="site-title-tagline">
                                <i className="far fa-passport"></i> সংবাদ ও ব্লগ
                            </span>
                            <h2 className="site-title">আমাদের সাম্প্রতিক সংবাদ ও ব্লগ</h2>
                        </div>
                    </div>
                </div>
                <div className="carousel-container">
                    <div className="blog-slider wow fadeInUp" data-wow-delay=".25s">
                        <Slider {...settings}>
                            {blogs.map((blog, index) => (
                                <div className="carousel-item" key={index}>
                                    <div className="blog-item wow fadeInUp m-1" data-wow-delay=".25s">
                                        <div className="blog-item-img">
                                            <img src={`${backendBaseUrl}${blog?.image}`} alt="thumb" />
                                        </div>
                                        <div className="blog-item-info">
                                            <h5 className="blog-title fw-bold text-dark">{blog?.title}</h5>
                                            <p className="text-dark mt-2">{blog?.short_description}</p>
                                            <Link className="theme-btn text-decoration-none" to={`/blog/details/${blog?.slug}`}>
                                                Read More <i className="fas fa-circle-arrow-right"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BLogCardHome;
